import { render, staticRenderFns } from "./Card-img.vue?vue&type=template&id=16f75e93&scoped=true&"
import script from "./Card-img.vue?vue&type=script&lang=js&"
export * from "./Card-img.vue?vue&type=script&lang=js&"
import style0 from "./Card-img.vue?vue&type=style&index=0&id=16f75e93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f75e93",
  null
  
)

export default component.exports